// VH-284: the open sessions list's query key, shared by the list and the
// password change (which ends the other sessions).
export const SESSIONS_QUERY_KEY = ['auth', 'sessions']
